import { isAfter, isBefore } from 'date-fns';
import { DatePeriod } from '@trg/api';

export function isNowBeforeDate(date: string): boolean {
  return isBefore(new Date(), new Date(date));
}

export function isNowAfterDate(date: string): boolean {
  return isAfter(new Date(), new Date(date));
}

export function inPeriod(activePeriod: DatePeriod): boolean {
  return (
    isNowAfterDate(activePeriod.startDateTime) &&
    isNowBeforeDate(activePeriod.endDateTime)
  );
}
